@if (!showAddresses) {
  <div class="form-group">
    <label class="form-group__label" [innerHtml]="question?.question_copy || question?.email_version || labelText"></label>
    <!-- the &#8204 (zero width character) between the word 'address' is important to help prevent the address field from being autofilled -->
    <!-- <label class="form-group__label">Search for an a&#8204;ddress</label> -->
    <form autocomplete="off" class="address-fields">
      <div class="form-group" [class.has-error]="showError">
        <div class="input-group">
          <input type="text"
            placeholder="Start typing..."
            autocomplete="one-time-code"
            maxlength="150"
            [attr.data-id]="question?.data_test_id"
            (focus)="onInputFocus($event)"
            (blur)="onInputBlur()"
            (input)="onInputChanged()"
            #addressText
            class="form-control"/>
            <div class="input-group-append">
              <span class="input-group-icon">
                <svg class="icon text-color-core">
                  <use xlink:href="#geo-locate"></use>
                </svg>
              </span>
            </div>
          </div>
          <small class="char-count">{{addressText.value?.length || 0}}/150</small>
          <label class="form-control-error" [class.d-none]="!showError">
            @if (errorReason === 'imprecise') {
              That address is too broad. Please include a street or building, or drag the map pin to the exact location.
            } @else {
              Please select a valid Google maps address
            }
          </label>
        </div>
        <div class="form-group d-none">
          <input type="hidden" [value]="gps" placeholder="GPS Co-ordinates" class="form-control"/>
        </div>
        <div [class.d-none]="!showAdditionalInfo">
          <div class="form-group mt-n15 address-textbox-add-details" [class.d-none]="!showAddDetailsLink">
            <a href="#add-address-details-modal" data-toggle="modal" class="link">
              <svg class="icon"><use xlink:href="#plus-small"></use></svg>
              <strong>Add unit or complex details, if applicable</strong>
            </a>
          </div>
          <div class="form-group mt-20 mt-md-25" [class.d-none]="!showUnit">
            <label>Apartment or unit number</label>
            <div class="input-group">
              <input type="text" [value]="apartmentNo" maxlength="10" (input)="onUnitChanged($event)" (blur)="emitAnswer()" class="form-control"/>
            </div>
            <small class="char-count">{{apartmentNo?.length || 0}}/10</small>
          </div>
          <div class="form-group mt-20 mt-md-25" [class.d-none]="!showComplex">
            <label>Complex or estate name</label>
            <div class="input-group">
              <input type="text" [value]="complex" maxlength="120" (input)="onComplexChanged($event)" (blur)="emitAnswer()" class="form-control"/>
            </div>
            <small class="char-count">{{complex?.length || 0}}/120</small>
          </div>
        </div>
        <div class="form-group" [class.d-none]="!mapVisible">
          <!-- label only shows when pickLocation is enabled-->
          <div class="form-group__label" [class.d-none]="!pickLocation || !showPin">Drag the marker around to pin-point your location if necessary</div>
          <div class="gmap gmap--lg mt-0" #mapCanvas></div>
        </div>
      </form>
    </div>
  }

  @if (showAddresses) {
    <div class="form-group">
      @for (add of addresses; track add) {
        <label class="tile">
          <input type="radio"
            (click)="setAddress(add)"
            [attr.data-id]="question?.data_test_id"
            [attr.data-answer]="add?.address"
            >
            <div class="tile__inner">
              <div class="tile__main">
                <div class="tile__content">
                  <div class="tile__indi"><span></span></div>
                  <div class="tile__label">
                    <div class="tile__title">{{add?.address}}</div>
                  </div>
                </div>
              </div>
            </div>
          </label>
        }
        <label class="tile">
          <input type="radio"
            (click)="setAddress('new')"
            [attr.data-id]="question?.data_test_id"
            >
            <div class="tile__inner">
              <div class="tile__main">
                <div class="tile__content">
                  <div class="tile__indi"><span></span></div>
                  <div class="tile__label">
                    <div class="tile__title">Not in the list</div>
                  </div>
                </div>
              </div>
            </div>
          </label>
        </div>
      }

      <!-- modal -->
      <div class="modal fade modal--mini" id="add-address-details-modal" tabindex="-1" role="dialog" aria-labelledby="add-address-details-modal" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content modal-mini">
            <div class="modal-mini__heading">
              <div class="container-fluid">
                <h4>Add unit or complex details</h4>
              </div>
            </div>

            <div class="modal-mini__content">
              <div class="container-fluid">
                <div class="form-group">
                  <label>Apartment or unit number</label>
                  <div class="input-group"><input type="text" placeholder="" maxlength="10" (input)="onModalFieldInput()" #modalUnitInput class="form-control" /></div>
                  <small class="char-count">{{modalUnitInput.value?.length || 0}}/10</small>
                </div>
                <div class="form-group">
                  <label>Complex or estate name</label>
                  <div class="input-group"><input type="text" placeholder="" maxlength="50" (input)="onModalFieldInput()" #modalComplexInput class="form-control" /></div>
                  <small class="char-count">{{modalComplexInput.value?.length || 0}}/50</small>
                </div>
              </div>
            </div>

            <div class="modal-mini__button">
              <div class="container-fluid">
                <a href="#" data-dismiss="modal" class="button button--secondary">Cancel</a>
                <a href="#" data-dismiss="modal" (click)="submitDetailsModal($event)" class="button button--primary">Add</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /modal -->
